import React from 'react';
import 'twin.macro';
import { Trans, useTranslation } from 'react-i18next';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { TRANSFER_DETAILS } from '.';

export function TransferPayment() {
  const { t } = useTranslation(['userSettings']);

  return (
    <>
      <div tw="p-4 bg-white rounded-lg flex flex-col gap-4">
        <p tw="text-sm">
          {t(
            'userSettings:schoolSubscription.payByBankTransfer.transfer.transferDetails',
          )}
        </p>
        <div tw="text-sm space-y-4">
          <p>
            <Trans
              i18nKey="userSettings:schoolSubscription.payByBankTransfer.transfer.accountHolder"
              components={{ bold: <span tw="font-semibold" /> }}
              values={{ accountHolder: TRANSFER_DETAILS.accountHolder }}
            />
          </p>
          <p>
            <Trans
              i18nKey="userSettings:schoolSubscription.payByBankTransfer.transfer.iban"
              components={{ bold: <span tw="font-semibold" /> }}
              values={{ iban: TRANSFER_DETAILS.iban }}
            />
          </p>
          <p>
            <Trans
              i18nKey="userSettings:schoolSubscription.payByBankTransfer.transfer.bic"
              components={{ bold: <span tw="font-semibold" /> }}
              values={{ bic: TRANSFER_DETAILS.bic }}
            />
          </p>
        </div>
        <div tw="flex gap-1 items-start">
          <InformationCircleIcon tw="w-5 h-5 text-neutral-moderate shrink-0" />
          <p tw="text-sm">
            {t(
              'userSettings:schoolSubscription.payByBankTransfer.transfer.reminder',
            )}
          </p>
        </div>
      </div>
      <div tw="mt-4 text-neutral-moderate text-sm">
        <span tw="font-semibold">
          {t(
            'userSettings:schoolSubscription.payByBankTransfer.transfer.invoiceQuestion',
          )}{' '}
        </span>
        {t(
          'userSettings:schoolSubscription.payByBankTransfer.transfer.invoiceContact',
        )}{' '}
        <a
          href={`mailto:${TRANSFER_DETAILS.email}?subject=${encodeURIComponent(t('userSettings:schoolSubscription.payByBankTransfer.transfer.invoiceEmailSubject'))}`}
        >
          {TRANSFER_DETAILS.email}
        </a>
        .
      </div>
    </>
  );
}
